import { BsQuestion } from 'react-icons/bs'
import {
    FaFaucet,
    FaThermometerEmpty,
    FaThermometerHalf,
    FaThermometerFull,
    FaFire
} from 'react-icons/fa'
import { GiHeatHaze, GiElectric } from 'react-icons/gi'
import { Tooltip } from 'evergreen-ui'

const getFullMeterTypeName = (type) => {
    switch (type) {
        case 'cold_water':
            return 'Woda zimna'
        case 'hot_water':
            return 'Woda ciepła'
        case 'garden_water':
            return 'Woda ogrodowa'
        case 'gas':
            return 'Gaz'
        case 'heat':
            return 'Ciepło'
        case 'electricity':
            return 'Elektryczność'
        case 'temperature':
            return 'Temperatura'
        case 'temp_cw_in':
            return 'Temperatura zimnej wody'
        case 'temp_dhw':
            return 'Temperatura ciepłej wody użytkowej'
        case 'temp_circ':
            return 'Temperatura cyrkulacji'
        case 'temp_ch_supply':
            return 'Temperatura zasilania CO'
        case 'temp_ch_return':
            return 'Temperatura powrotu CO'
        case 'temp_boiler_out':
            return 'Temperatura wyjścia z kotła'
        default:
            return 'Niezdefiniowany'
    }
}

const renderMeterIconType = (row, size, showTooltip = false) => {
    const content = (() => {
        switch (row?.type) {
            case 'cold_water':
                return (
                    <span>
                        <FaThermometerEmpty className="icon_blue" size={size} />
                        Woda zimna
                    </span>
                )
            case 'hot_water':
                return (
                    <span>
                        <FaThermometerFull className="icon_red" size={size} />
                        Woda ciepła
                    </span>
                )
            case 'garden_water':
                return (
                    <span>
                        <FaFaucet className="icon_green" size={size} /> Woda ogrodowa
                    </span>
                )
            case 'gas':
                return (
                    <span>
                        <FaFire className="icon_blue" size={size} /> Gaz
                    </span>
                )
            case 'heat':
                return (
                    <span>
                        <GiHeatHaze className="icon_red" size={size} /> Ciepło
                    </span>
                )
            case 'electricity':
                return (
                    <span>
                        <GiElectric className="icon_yellow" size={size} /> Prąd
                    </span>
                )
            case 'temperature':
                return (
                    <span>
                        <FaThermometerHalf className="icon_green" size={size} /> Temperatura
                    </span>
                )
            case 'temp_cw_in':
                return (
                    <span>
                        <FaThermometerEmpty className="icon_blue" size={size} />
                        Tzw
                    </span>
                )
            case 'temp_dhw':
                return (
                    <span>
                        <FaThermometerFull className="icon_red" size={size} />
                        Tcwu
                    </span>
                )
            case 'temp_circ':
                return (
                    <span>
                        <FaThermometerHalf className="icon_yellow" size={size} />
                        Tcyrk
                    </span>
                )
            case 'temp_ch_supply':
                return (
                    <span>
                        <FaThermometerFull className="icon_red" size={size} />
                        Temp. zasilania CO
                    </span>
                )
            case 'temp_ch_return':
                return (
                    <span>
                        <FaThermometerHalf className="icon_blue" size={size} />
                        Temp. powrotu CO
                    </span>
                )
            case 'temp_boiler_out':
                return (
                    <span>
                        <FaThermometerFull className="icon_red" size={size} />
                        Temp. wyjścia z kotła
                    </span>
                )
            default:
                return (
                    <span>
                        <BsQuestion size={size} />
                        Niezdefiniowany
                    </span>
                )
        }
    })()

    if (showTooltip) {
        return (
            <Tooltip content={getFullMeterTypeName(row?.type)} showDelay={500}>
                {content}
            </Tooltip>
        )
    }

    return content
}

export default renderMeterIconType
